import type { ICommunePayload } from '@/modules/cart/domain/AddressCommune';
import environment from '@/modules/cart/environments/environment';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';

const { CART_URL } = environment;

const COMMUNE_URL = `${CART_URL}/shipping-address/commune`;

export async function createShippingAddressCommune(
  address: ICommunePayload
): Promise<{ data: HttpCartDto }> {
  return await httpClient.patch(COMMUNE_URL, address);
}
